"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactPopper = require("react-popper");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwShellLeftNavButton = _interopRequireDefault(require("./CwShellLeftNavButton.scss"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _constants = require("../constants");

var _CwLabel = _interopRequireDefault(require("../../cwlabel/CwLabel"));

var CwShellLeftNavButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwShellLeftNavButton, _React$Component);

  function CwShellLeftNavButton() {
    var _this;

    (0, _classCallCheck2.default)(this, CwShellLeftNavButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwShellLeftNavButton).call(this));
    _this.closeNavTimeout = null;
    _this.hoverNavTimeout = null;
    _this.state = {
      mouseOver: false
    };
    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CwShellLeftNavButton, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      var _this2 = this; // clear closeNavTimeout


      window.clearTimeout(this.closeNavTimeout); // fire onMouseEnter callback if it exists

      if (typeof this.props.onMouseEnter === 'function') {
        this.props.onMouseEnter();
      } // set this as the active button if the menu is in DEFAULT mode


      if (this.props.expand === _constants.CwShellLeftNavExpand.DEFAULT && typeof this.props.setActiveButton === 'function') {
        this.props.setActiveButton(this.props.id);
      } // set hover state


      this.hoverNavTimeout = window.setTimeout(function () {
        _this2.setState({
          mouseOver: true
        });
      }, 500);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      var _this3 = this; // clear hoverNavTimeout


      window.clearTimeout(this.hoverNavTimeout); // fire onMouseLeave callback if it exists

      if (typeof this.props.onMouseLeave === 'function') {
        this.props.onMouseLeave();
      } // set null as the active button if the menu is in DEFAULT or SKINNY mode


      if ((this.props.expand === _constants.CwShellLeftNavExpand.DEFAULT || this.props.expand === _constants.CwShellLeftNavExpand.SKINNY) && typeof this.props.setActiveButton === 'function') {
        this.closeNavTimeout = window.setTimeout(function () {
          if (_this3.props.active) {
            _this3.props.setActiveButton(null);
          }
        }, 500);
      } // set hover state


      this.setState({
        mouseOver: false
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      // fire onClick callback if it exists
      if (typeof this.props.onClick === 'function') {
        this.props.onClick();
      } // set this as the active button if the menu is in FAT or SKINNY mode


      if ((this.props.expand === _constants.CwShellLeftNavExpand.FAT || this.props.expand === _constants.CwShellLeftNavExpand.SKINNY) && typeof this.props.setActiveButton === 'function') {
        this.props.setActiveButton(this.props.active ? null : this.props.id);
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this4 = this;

      return _react.default.Children.map(this.props.children, function (child) {
        return _react.default.cloneElement(child, {
          cwId: _this4.props.cwId,
          active: _this4.props.activeLink === child.props.id,
          collapseIcon: _this4.props.collapseIcon,
          expandIcon: _this4.props.expandIcon,
          setActiveLink: _this4.props.setActiveLink,
          noBorder: _this4.props.expand === _constants.CwShellLeftNavExpand.SKINNY
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _cx, _cx2;

      var buttonClass = (0, _classnames.default)(_CwShellLeftNavButton.default.cwShellLeftNavButton, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwShellLeftNavButton.default.collapsed, this.props.expand === _constants.CwShellLeftNavExpand.COLLAPSED), (0, _defineProperty2.default)(_cx, _CwShellLeftNavButton.default.default, this.props.expand === _constants.CwShellLeftNavExpand.DEFAULT), (0, _defineProperty2.default)(_cx, _CwShellLeftNavButton.default.fat, this.props.expand === _constants.CwShellLeftNavExpand.FAT), (0, _defineProperty2.default)(_cx, _CwShellLeftNavButton.default.skinny, this.props.expand === _constants.CwShellLeftNavExpand.SKINNY), (0, _defineProperty2.default)(_cx, _CwShellLeftNavButton.default.active, this.props.active), _cx));
      var linkContainerClass = (0, _classnames.default)(_CwShellLeftNavButton.default.cwShellLeftNavLinkContainer, (_cx2 = {}, (0, _defineProperty2.default)(_cx2, _CwShellLeftNavButton.default.default, this.props.expand === _constants.CwShellLeftNavExpand.DEFAULT), (0, _defineProperty2.default)(_cx2, _CwShellLeftNavButton.default.skinny, this.props.expand === _constants.CwShellLeftNavExpand.SKINNY), _cx2));
      var iconClass = (0, _classnames.default)(_CwShellLeftNavButton.default.cwShellLeftNavButtonIcon, (0, _defineProperty2.default)({}, _CwShellLeftNavButton.default.skinny, this.props.expand === _constants.CwShellLeftNavExpand.SKINNY));
      return _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_button_").concat(this.props.id, "_container"),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        style: this.props.style
      }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_button_").concat(this.props.id),
        className: buttonClass,
        onClick: this.handleClick
      }, _react.default.createElement(_CwImage.default, {
        cwId: "".concat(this.props.cwId, "_button_").concat(this.props.id, "_icon"),
        className: iconClass,
        src: this.props.icon
      }), this.props.expand !== _constants.CwShellLeftNavExpand.SKINNY && _react.default.createElement(_CwLabel.default, {
        cwId: "".concat(this.props.cwId, "_button_").concat(this.props.id, "_label"),
        className: _CwShellLeftNavButton.default.cwShellLeftNavButtonLabel
      }, this.props.label)), this.props.active && this.props.children && _react.default.createElement("div", {
        className: linkContainerClass
      }, this.renderChildren())), this.state.mouseOver && !this.props.active && _react.default.createElement(_reactPopper.Popper, {
        placement: "right",
        modifiers: {
          preventOverflow: {
            enabled: false
          },
          hide: {
            enabled: false
          }
        },
        positionFixed: true
      }, _react.default.createElement("div", {
        className: _CwShellLeftNavButton.default.buttonPopper
      }, this.props.label), _react.default.createElement(_reactPopper.Arrow, {
        className: _CwShellLeftNavButton.default.arrow
      }))));
    }
  }]);
  return CwShellLeftNavButton;
}(_react.default.Component);

;
CwShellLeftNavButton.propTypes = {
  children: _propTypes.default.any,

  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes.default.string,

  /**
   * Unique identifier
   */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Determines if the 'active' class is applied to button and if children are shown
   */
  active: _propTypes.default.bool,

  /**
   * Current active link
   */
  activeLink: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Path to collapse icon to pass to CwShellLeftNavLink children
   */
  collapseIcon: _propTypes.default.string,

  /**
   * Path to expand icon to pass to CwShellLeftNavLink children
   */
  expandIcon: _propTypes.default.string,

  /**
   * State of the parent CwShellLeftNav component
   */
  expand: _propTypes.default.oneOf([_constants.CwShellLeftNavExpand.COLLAPSED, _constants.CwShellLeftNavExpand.DEFAULT, _constants.CwShellLeftNavExpand.FAT, _constants.CwShellLeftNavExpand.SKINNY]),

  /**
   * Path to main icon
   */
  icon: _propTypes.default.string.isRequired,

  /**
   * Text Displayed
   */
  label: _propTypes.default.string.isRequired,

  /**
   * Callback function that is fired on mouse click
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function that is fired on mouse enter
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * Callback function that is fired on mouse leave
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * Callback function to set the active button
   */
  setActiveButton: _propTypes.default.func,

  /**
   * Callback function to set the active link
   */
  setActiveLink: _propTypes.default.func,

  /**
   * Allows custom styling
   */
  style: _propTypes.default.object
};
var _default = CwShellLeftNavButton;
exports.default = _default;